import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant.js';

export const FJSliceAIAudioGenerator = createSlice({
    name: 'AIAudioGenerator',
    initialState: {
        tabIndex: 0,
        incidentalAudioInfo: {}, // 参考配乐
        uploadIncidentalAudioStatus: FJConstant.DEFAULT,
        audioInfo: {}, // 参考音乐
        uploadAudioStatus: FJConstant.DEFAULT,
        vocalAudioInfo: {}, // 人声
        uploadVocalAudioStatus: FJConstant.DEFAULT,
        lyricContent: '',
        lyricDesc: '',
        presetList: [],
        referenceMusicList: [],
        referenceVocalList: [],
        instrumentalList: [],
        isGenerateLyricsLoading: false,
        isMultipleMode: false,
        isDraggingVoiceFile: false,
    },
    reducers: {
        setSliceIsMultipleMode: (state, action) => {
            state.isMultipleMode = action.payload;
        },
        setSliceIsGenerateLyricsLoading: (state, action) => {
            state.isGenerateLyricsLoading = action.payload;
        },
        setSliceIncidentalAudioInfo: (state, action) => {
            state.incidentalAudioInfo = action.payload;
        },
        setSliceAudioInfo: (state, action) => {
            state.audioInfo = action.payload;
        },
        setSliceVocalAudioInfo: (state, action) => {
            state.vocalAudioInfo = action.payload;
        },
        setSliceLyricContent: (state, action) => {
            state.lyricContent = action.payload;
        },
        setSliceLyricDesc: (state, action) => {
            state.lyricDesc = action.payload;
        },
        setSliceTabIndex: (state, action) => {
            state.tabIndex = action.payload;
        },
        setSliceUploadAudioStatus: (state, action) => {
            state.uploadAudioStatus = action.payload;
        },
        setSliceVocalUploadAudioStatus: (state, action) => {
            state.uploadVocalAudioStatus = action.payload;
        },
        setSliceIncidentalAudioStatus: (state, action) => {
            state.uploadIncidentalAudioStatus = action.payload;
        },
        setSlicePresetList: (state, action) => {
            state.presetList = action.payload;
        },
        setSliceReferenceMusicList: (state, action) => {
            state.referenceMusicList = action.payload;
        },
        setSliceReferenceVocalList: (state, action) => {
            state.referenceVocalList = action.payload;
        },
        setSliceInstrumentalList: (state, action) => {
            state.instrumentalList = action.payload;
        },
        setSliceIsDraggingVoiceFile: (state, action) => {
            state.isDraggingVoiceFile = action.payload;
        },
    },
});

export const {
    setSliceLyricDesc,
    setSliceTabIndex,
    setSliceLyricContent,
    setSliceIncidentalAudioInfo,
    setSliceAudioInfo,
    setSliceVocalAudioInfo,
    setSliceUploadAudioStatus,
    setSliceVocalUploadAudioStatus,
    setSliceIncidentalAudioStatus,
    setSlicePresetList,
    setSliceReferenceMusicList,
    setSliceReferenceVocalList,
    setSliceInstrumentalList,
    setSliceIsGenerateLyricsLoading,
    setSliceIsMultipleMode,
    setSliceIsDraggingVoiceFile,
} = FJSliceAIAudioGenerator.actions;

export default FJSliceAIAudioGenerator.reducer;
